export const SEARCH_TERMS = ["title"];
export const inputFields = {
  title: {
    type: "string",
    required: true,
    title: "Title",
    slug: true,
    inputType: "text",
  },
  description: {
    type: "html",
    required: false,
    title: "Description",
  },
  product_image: {
    type: "file",
    required: false,
    title: "Product Image",
  },
  product_price: {
    type: "string",
    required: true,
    title: "Product Price",
    inputType: "number",
  },
  goal: {
    type: "string",
    required: true,
    title: "Goal",
    inputType: "number",
  },
  achieved: {
    type: "string",
    required: true,
    title: "Achieved",
    inputType: "number",
  },
  gallery: {
    type: "gallery",
    required: false,
    title: "Gallery",
  },
  meta_title: {
    type: "string",
    required: false,
    title: "Meta Title",
  },
  meta_description: {
    type: "text",
    required: false,
    title: "Meta Description",
  },
  slug: {
    type: "slug",
    required: false,
    targetField: "title",
    title: "Slug",
  },
};
export const initialValues = {
  title: "",
  description: "",
  product_price: "",
  goal: "",
  achieved: "",
  meta_title: "",
  meta_description: "",
  slug: "",
};

export const view_all_table = [
  { name: "Title", value: "title" },
  { name: "Product Price", value: "product_price" },
  { name: "Goal", value: "goal" },
  { name: "Achieved", value: "achieved" },
  { name: "Slug", value: "slug" },
];
